// =====================================================
// CENTRALIZED DESIGN TOKENS — Coral Red + Neutral Grays
// Brand palette for Paras Road Lines Dashboard
// =====================================================

// ─── BRAND (Primary) ────────────────────────────────
export const brand = {
  main:   '#DC2626',   // all primary buttons, active nav, links, chip text
  dark:   '#B91C1C',   // hover on primary buttons
  light:  '#EF4444',
  50:     '#FEF2F2',   // soft red hover backgrounds, chip bg, badge bg
  100:    '#FEE2E2',   // slightly stronger red tint
  200:    '#FECACA',   // borders on red chips/badges
};

// ─── STATUS COLORS ───────────────────────────────────
export const status = {
  success: {
    main:   '#10B981',
    bg:     '#ECFDF5',   // badge background
    dark:   '#059669',
    border: '#A7F3D0',
  },
  warning: {
    main:   '#F59E0B',
    bg:     '#FFFBEB',   // badge background — soft yellow
    dark:   '#D97706',
    border: '#FDE68A',
  },
  info: {
    main:   '#3B82F6',
    bg:     '#EFF6FF',   // badge background — soft blue
    dark:   '#2563EB',
    border: '#BFDBFE',
  },
  error: {
    main:   '#EF4444',
    bg:     '#FEF2F2',
    dark:   '#DC2626',
    border: '#FECACA',
  },
};

// ─── ACTION BUTTON COLORS (row action icons in tables) ──
export const actionButtons = {
  view: {
    text:   '#0891B2',
    bg:     '#ECFEFF',
    border: '#A5F3FC',
  },
  edit: {
    text:   '#EA580C',
    bg:     '#FFF7ED',
    border: '#FED7AA',
  },
  delete: {
    text:   '#DC2626',
    bg:     '#FEF2F2',
    border: '#FECACA',
  },
};

// ─── NEUTRAL (Grays) ─────────────────────────────────
export const neutral = {
  50:  '#F9FAFB',   // table header bg, subtle page bg
  100: '#F3F4F6',
  200: '#E5E7EB',   // default borders, dividers
  300: '#D1D5DB',
  400: '#9CA3AF',   // placeholder text, muted icons
  500: '#6B7280',   // secondary text
  600: '#4B5563',
  700: '#374151',   // table header text, body text
  800: '#1F2937',
  900: '#0F172A',   // primary text, headings
};

// ─── SURFACE ─────────────────────────────────────────
export const surface = {
  pageBg:        '#FAFAFA',
  cardBg:        '#FFFFFF',
  inputBg:       '#FFFFFF',
  borderLight:   '#F1F5F9',   // hairline table row borders
  borderDefault: '#E5E7EB',   // input borders, card borders
};

// ─── TEXT ────────────────────────────────────────────
export const text = {
  primary:   '#0F172A',   // headings, table values
  secondary: '#6B7280',   // labels, subtitles
  muted:     '#9CA3AF',   // placeholders, disabled
  inverse:   '#FFFFFF',   // text on colored buttons/chips
};

// ─── RADIUS ─────────────────────────────────────────
export const radius = {
  sm: 6,    // chips, badges, small buttons
  md: 8,    // buttons, icon buttons, action buttons
  lg: 10,   // input fields, search bars
  xl: 12,   // cards, table wrappers
};

// ─── SHADOWS ────────────────────────────────────────
export const shadows = {
  sm:    '0 1px 2px rgba(16,24,40,.04)',
  md:    '0 1px 3px rgba(16,24,40,.06)',
  card:  '0 1px 4px rgba(0,0,0,0.04)',
  lg:    '0 4px 12px rgba(16,24,40,.08)',
  brand: '0 4px 12px rgba(220,38,38,.25)',   // for primary button hover
};
